import { gql } from "@apollo/client";

export const GetAlterAgreementRecordPage = gql`
  query GetAlterAgreementRecordPage(
    $pagination: PaginationInput!
    $locationId: String!
  ) {
    alterAgreementRecordPage(pagination: $pagination, locationId: $locationId) {
      items {
        id
        signedAgreement {
          id
          status
          agreement {
            id
            name
            paymentFrequency
          }
          client {
            id
            user {
              id
              firstName
              lastName
            }
          }
        }
        alterationAgreementStatus
        alterationAgreementType
        notes
        reason {
          id
          reason
        }
        startFreezeAt
        intervals
        reviewedBy {
          id
          firstName
          lastName
        }
        reviewedAt
        createdDate
      }
      totalRows
    }
  }
`;

export const GetAgreementRequests = gql`
  query GetAgreementRequests($clientId: String!) {
    agreementRequests(clientId: $clientId) {
      id
      signedAgreement {
        id
      }
      alterationAgreementStatus
    }
  }
`;
